import React from 'react'

function RoadMap() {
  return (
    <div id="roadmap" className="basic-1">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h1 className="blue text-center">AI IMPLEMENTATION ROADMAP</h1>
            <section id="cd-timeline" className="cd-container">
              <div className="cd-timeline-block">
                <div className="cd-timeline-img cd-picture">
                </div>
  
                <div className="cd-timeline-content">
                  <div className="timeline-content-info">
                    <span className="timeline-content-info-date">&nbsp;
                      <i className="fa fa-calendar-o" aria-hidden="true"></i>
                      Phase 1: Weeks 1-2
                    </span>
                  </div>
                  <h2>Assessment and Planning</h2>
                  <ul className="king-roadmap">
                    <li>Comprehensive business analysis and <b>AI readiness assessment</b></li>
                    <li>Identification of high-impact use cases and implementation priorities</li>
                    <li>Development of customized AI transformation roadmap</li>
                    <li>Stakeholder alignment and change management planning</li>
                  </ul>
                </div> 
              </div> 
  
              <div className="cd-timeline-block">
                <div className="cd-timeline-img cd-movie">
                </div> 
  
                <div className="cd-timeline-content">
                  <div className="timeline-content-info">
                    <span className="timeline-content-info-date">&nbsp;
                      <i className="fa fa-calendar-o" aria-hidden="true"></i>
                      Phase 2: Weeks 3-6
                    </span>
                  </div>
                  <h2>Foundation Setup</h2>
                  <ul className="king-roadmap">
                    <li>Infrastructure preparation and <b>security configuration</b></li>
                    <li>Initial AI model deployment and testing</li>
                    <li><b>MCP integration</b> with existing data sources</li>
                    <li>Team training and knowledge transfer initiation</li>
                    <li>Enterprise-grade governance and compliance setup</li>
                  </ul>
                </div> 
              </div> 
  
              <div className="cd-timeline-block">
                <div className="cd-timeline-img cd-picture">
                </div> 
  
                <div className="cd-timeline-content">
                  <div className="timeline-content-info">
                    <span className="timeline-content-info-date">&nbsp;
                      <i className="fa fa-calendar-o" aria-hidden="true"></i>
                      Phase 3: Weeks 7-10
                    </span>
                  </div>
                  <h2>Pilot Implementation</h2>
                  <ul className="king-roadmap">
                    <li>Deployment of first <b>AI agents</b> for selected use cases</li> 
                    <li>Real-world testing and performance optimization</li>
                    <li>User feedback collection and system refinement</li>
                    <li>Success metrics establishment and baseline measurement</li>
                  </ul>
                </div> 
              </div> 
  
              <div className="cd-timeline-block">
                <div className="cd-timeline-img cd-location">
                </div> 
  
                <div className="cd-timeline-content">
                  <div className="timeline-content-info">
                    <span className="timeline-content-info-date">&nbsp;
                      <i className="fa fa-calendar-o" aria-hidden="true"></i>
                      Phase 4: Weeks 11-16
                    </span>
                  </div>
                  <h2>Scaled Deployment</h2>
                  
                  <ul className="king-roadmap">
                    <li>Expansion of AI capabilities across <b>additional business processes</b></li>
                    <li>Advanced <b>agent orchestration</b> and workflow automation</li>
                    <li><b>Blockchain integration</b> for enhanced security and transparency</li>
                    <li>Comprehensive performance monitoring and optimization</li>
                  </ul>
                  
                </div> 
              </div> 
              <div className="cd-timeline-block">
                <div className="cd-timeline-img cd-location">
                </div>
  
                <div className="cd-timeline-content">
                  <div className="timeline-content-info">
                    <span className="timeline-content-info-date">&nbsp;
                      <i className="fa fa-calendar-o" aria-hidden="true"></i>
                      Phase 5: Ongoing
                    </span>
                  </div>
                  <h2>Optimization and Growth</h2>
                  <ul className="king-roadmap">
                    <li>Continuous system improvement and <b>capability expansion</b></li>
                    <li>Advanced analytics and business intelligence enhancement</li>
                    <li>New use case identification and implementation</li>
                    <li>Long-term strategic planning and <b>technology roadmap</b> updates</li>
                    <li>Ongoing support and <b>ROI optimization</b></li>
                    <li>Regular performance reviews and system upgrades</li>
                  </ul>
                </div> 
              </div>   
            </section>
            </div> 
        </div> 
      </div> 
    </div> 

  )
}

export default RoadMap